<app-generic-field [label]="label" [hideLabel]="hideLabel">
  <input type="text" [ngModel]="value" (ngModelChange)="valueChange.emit($event)" [placeholder]="placeholder ?? ''"
         (keyup.enter)="enter.emit(value)" [disabled]="disabled" pInputText>
</app-generic-field>
